import { create } from 'zustand';

interface PageAlertState {
  // 알림 상태
  alertType: 'success' | 'error' | 'loading' | null;
  alertMessage: string | null;
  alertSubMessage: string | null;
  onAlertClick: (() => void) | null;

  // 버튼 상태 (메인 버튼)
  showButton: boolean;
  buttonLabel: string | null;
  buttonLoading: boolean;
  onButtonClick: (() => void) | null;

  // 보조 버튼 상태
  showSecondaryButton: boolean;
  secondaryButtonLabel: string | null;
  secondaryButtonLoading: boolean;
  secondaryButtonDisabled: boolean;
  onSecondaryButtonClick: (() => void) | null;

  // 액션
  setAlert: (
    type: 'success' | 'error' | 'loading',
    message: string,
    subMessage?: string,
    onClick?: () => void
  ) => void;
  clearAlert: () => void;
  setButton: (label: string, onClick: () => void, loading?: boolean) => void;
  setButtonLoading: (loading: boolean) => void;
  clearButton: () => void;
  setSecondaryButton: (label: string, onClick: () => void, disabled?: boolean, loading?: boolean) => void;
  setSecondaryButtonDisabled: (disabled: boolean) => void;
  clearSecondaryButton: () => void;
  clearAll: () => void;
}

export const usePageAlertStore = create<PageAlertState>((set) => ({
  alertType: null,
  alertMessage: null,
  alertSubMessage: null,
  onAlertClick: null,

  showButton: false,
  buttonLabel: null,
  buttonLoading: false,
  onButtonClick: null,

  showSecondaryButton: false,
  secondaryButtonLabel: null,
  secondaryButtonLoading: false,
  secondaryButtonDisabled: false,
  onSecondaryButtonClick: null,

  setAlert: (type, message, subMessage, onClick) =>
    set({
      alertType: type,
      alertMessage: message,
      alertSubMessage: subMessage || null,
      onAlertClick: onClick || null,
    }),

  clearAlert: () =>
    set({
      alertType: null,
      alertMessage: null,
      alertSubMessage: null,
      onAlertClick: null,
    }),

  setButton: (label, onClick, loading = false) =>
    set({
      showButton: true,
      buttonLabel: label,
      onButtonClick: onClick,
      buttonLoading: loading,
    }),

  setButtonLoading: (loading) =>
    set({ buttonLoading: loading }),

  clearButton: () =>
    set({
      showButton: false,
      buttonLabel: null,
      buttonLoading: false,
      onButtonClick: null,
    }),

  setSecondaryButton: (label, onClick, disabled = false, loading = false) =>
    set({
      showSecondaryButton: true,
      secondaryButtonLabel: label,
      onSecondaryButtonClick: onClick,
      secondaryButtonDisabled: disabled,
      secondaryButtonLoading: loading,
    }),

  setSecondaryButtonDisabled: (disabled) =>
    set({ secondaryButtonDisabled: disabled }),

  clearSecondaryButton: () =>
    set({
      showSecondaryButton: false,
      secondaryButtonLabel: null,
      secondaryButtonLoading: false,
      secondaryButtonDisabled: false,
      onSecondaryButtonClick: null,
    }),

  clearAll: () =>
    set({
      alertType: null,
      alertMessage: null,
      alertSubMessage: null,
      onAlertClick: null,
      showButton: false,
      buttonLabel: null,
      buttonLoading: false,
      onButtonClick: null,
      showSecondaryButton: false,
      secondaryButtonLabel: null,
      secondaryButtonLoading: false,
      secondaryButtonDisabled: false,
      onSecondaryButtonClick: null,
    }),
}));